import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state) => state.status === 'authenticated',
);

export const selectAuthStatus = createSelector(selectAuthState, (state) => state.status);

export const selectAuthToken = createSelector(selectAuthState, (state) => state.token);

export const selectCurrentUser = createSelector(selectAuthState, (state) => ({
  userId: state.userId,
  displayName: state.displayName,
  email: state.email,
}));
